














































































import { Vue, Component, Prop } from 'vue-property-decorator';
import { Action, State } from 'vuex-class';

import { criiptoUpdatedSubscription } from '@signing-page/api/integrations/graphql/integration.subscriptions';
import { userLanguage } from '@signing-page/lang';
import { EBankIdSigningType, EBankIdStep } from '@signing-page/signing/types/enums/bankid-se';
import { IBankId } from '@signing-page/signing/types/bankid';
import { ESigningAction, namespace } from '@signing-page/signing/store/signing.constants';
import { IEId } from '@signing-page/signing/types/eid';
import { ECriiptoStatus } from '@signing-page/signing/types/enums/criipto-status';
import BankIdSe from '@signing-page/signing/components/modals/BankIdSe.vue';
import Criipto from '@signing-page/signing/components/modals/Criipto.vue';
import { getEIdOptions } from '@signing-page/signing/constants/eid-options.ts';
import Accordion from '@/components/Accordion.vue';
import Icon from '@/components/Icon.vue';
import BankIdOption from '@signing-page/signing/components/BankIdOption.vue';
import Dropdown from '@/components/Dropdown.vue';
import { EButtonTypes } from '@/enums/ButtonType.ts';
import Button from '@/components/Button.vue';

@Component({
  components: {
    BankIdSe,
    Accordion,
    Icon,
    BankIdOption,
    Dropdown,
    Criipto,
    Button,
  },
  data: () => ({
    EButtonTypes,
    EBankIdStep,
  }),
})
export default class Eid extends Vue {
  @Prop() documentId: string;
  @Prop() recipientId: string;
  @Prop() authId: string;
  @Prop() jwt!: string;
  @Prop() reviewPending: boolean;

  @State('bankId', { namespace }) bankId: IBankId;
  @Action(ESigningAction.CancelBankIdTransaction, { namespace }) actionCancelBankIdTransaction: any;
  @Action(ESigningAction.PollBankIdTransaction, { namespace }) pollBankIdTransaction: any;
  @Action(ESigningAction.SetBankIdState, { namespace }) setBankIdState: any;

  selectedEId: IEId = null;
  openBankIdPicker: number = null;
  criiptoStatus: ECriiptoStatus = ECriiptoStatus.Default;
  options: IEId[] = [];

  get showBankIDSe(): boolean {
    return !!this.selectedEId && this.selectedEId.key === 'SE';
  }

  get showCriipto(): boolean {
    return this.selectedEId && this.selectedEId.key !== 'SE';
  }

  get showHeader(): boolean {
    return !this.showCriipto || this.criiptoStatus !== ECriiptoStatus.Loading;
  }

  get bankIdStarted(): boolean {
    return this.bankId.signingType !== EBankIdSigningType.None;
  }

  handleRecipientsInput(selectedEid: IEId) {
    this.handleCancelBankId();
    this.selectedEId = selectedEid;
    this.openBankIdPicker = null;
  }

  handleCriiptoStatus(status: ECriiptoStatus) {
    this.criiptoStatus = status;
    if (status === ECriiptoStatus.Success) {
      this.handleSignDocument();
    }
  }

  handleCancelBankId() {
    this.actionCancelBankIdTransaction();
  }

  handleSignDocument() {
    if (this.reviewPending) {
      this.handleClose();
      return;
    }
    this.$emit('sign');
    this.actionCancelBankIdTransaction();
  }

  handleToggleBankIdPicker(open: number) {
    this.openBankIdPicker = open;
  }

  handleClose() {
    this.handleCancelBankId();
    this.$emit('close');
  }

  addCriiptoSubscription(): void {
    this.$apollo.addSmartSubscription('criiptoUpdatedSubscription', {
      query: criiptoUpdatedSubscription,
      variables: { recipientId: this.recipientId },
      result({ data }) {
        this.handleCriiptoStatus(data.criiptoUpdated);
      },
    });
  }

  get defaultBankIdOption(): IEId {
    switch (userLanguage()) {
      case 'sv':
        return this.options.find(option => option.key === 'SE');
      case 'da':
        return this.options.find(option => option.key === 'bankid-dk');
      case 'no':
      case 'nn':
      case 'nb':
        return this.options.find(option => option.key === 'bankid-no-mobile');
      default:
        return this.options.find(option => option.key === 'SE');
    }
  }

  mounted() {
    this.options = getEIdOptions();
    this.selectedEId = this.defaultBankIdOption;
    this.addCriiptoSubscription();
  }

  created() {
    if (this.bankId.orderRef) {
      this.pollBankIdTransaction({
        orderRef: this.bankId.orderRef,
        documentId: this.documentId,
        recipientId: this.recipientId,
      });
    }
  }
}
